/**
 * ElitAuthWrapper Component
 *
 * This is a wrapper component created to solve TypeScript build errors with the original ElitAuthProvider.
 * The original component from @elit-hair/elit-tools has type issues that prevent successful builds.
 *
 * Problem:
 * 1. The original ElitAuthProvider has a return type that TypeScript doesn't recognize as a valid JSX element
 * 2. There are prop type mismatches, particularly with the 'authServices' prop
 *
 * Solution:
 * This wrapper component uses the 'any' type and @ts-ignore to bypass TypeScript's type checking
 * while preserving all the functionality of the original component.
 *
 * Note: This is a temporary solution until the original package is updated with proper TypeScript definitions.
 * When the original package is fixed, this wrapper can be removed and the original component can be used directly.
 */
import { ElitAuthProvider as OriginalElitAuthProvider } from "@elit-hair/elit-tools";
import React from "react";

/**
 * ElitAuthWrapper component that wraps the original ElitAuthProvider
 * to bypass TypeScript errors while maintaining all functionality.
 *
 * @param props - All props are passed directly to the original ElitAuthProvider
 * @returns The original ElitAuthProvider with all props passed through
 */
export const ElitAuthWrapper: React.FC<any> = (props) => {
    // @ts-ignore - Ignore TypeScript errors related to the component's return type and prop types
    return <OriginalElitAuthProvider {...props} />;
};

export default ElitAuthWrapper;
